define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.MobileAlertService = function (TranslateService, lpConstants, $rootScope, lpCoreError) {

        function getContinueButton() {
            return {
                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
                text: TranslateService.translate('abc.common.button.continue'),
                callback: null
            };
        }

        function getCloseButton() {
            return {
                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
                text: TranslateService.translate('abc.common.button.close'),
                callback: null
            };
        }

        function getOkButton() {
            return {
                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
                text: TranslateService.translate('abc.common.button.ok'),
                callback: null
            };
        }

        function show(message, buttons) {
            if (!buttons || buttons.length === 0) {
                lpCoreError.throwException('Should have buttons, else cannot close notification');
                return;
            }
            const buttonsForSdk = [];
            buttons.forEach(function (button, index) {
                buttonsForSdk.push({
                    type: button.type,
                    text: button.text,
                    callbackFn: index.toString()
                });
            });
            try {
                window.cxp.mobile.plugins['AlertDialog'].show(buttonHandler.bind(this, buttons), null, "", TranslateService.translate(message), JSON.stringify(buttonsForSdk));
            }
            catch (e) {
                lpCoreError.throwException('Error getting [AlertDialog] plugin from sdk.');
            }

        }

        function buttonHandler(buttons, data) {
            const callbackIndex = parseInt(data.callback);
            if (!isNaN(callbackIndex)) {
                const buttonTapped = buttons[callbackIndex];
                !!buttonTapped.callback && buttonTapped.callback();
            }
        }

        function showProcessing(message){
            const i18nMessage = TranslateService.translate(message);
            $rootScope.loaderMessage = i18nMessage;
            gadgets.pubsub.publish(lpConstants.PUBLISH.SHOW_PROGRESS, { "alertTitle": i18nMessage});
        }
        
        // public API
        return {
            show: show,
            getContinueButton: getContinueButton,
            getOkButton: getOkButton,
            getCloseButton: getCloseButton,
            showProcessing: showProcessing
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/mobile-alert-service.js
// module id = 5
// module chunks = 0